(function ($, Drupal, settings) {

  'use strict';

  Drupal.behaviors.GAUser = {
    attach: function (context, settings) {

      // Trigger the GA event (User clicks the Log In link (all places))
      $(once('eAuthClickLogin', "a[href^='/saml/login'], a[href^='/user/login']", context)).each(function() {
        $(this).click(function() {
          if (!$(this).data('mp-ga-user-login-sent')) {
            // New
            Drupal.analyticsEventNew('click', {
              link_id: 'log-in',
              label: 'Log In'
            });
            //Old
            Drupal.analyticsEvent('Click', 'eAuth', 'Log In');
            $(this).data('mp-ga-user-login-sent', true);
          }
        });
      });

      // Trigger the GA event (User clicks the Log Out link (all places))
      $(once('eAuthClickLogout', "a[href^='/saml/logout'], a[href^='/user/logout']", context)).each(function() {
        $(this).click(function() {
          if (!$(this).data('mp-ga-user-logout-sent')) {
            // New
            Drupal.analyticsEventNew('click', {
              link_id: 'log-out',
              label: 'Log Out'
            });
            //Old
            Drupal.analyticsEvent('Click', 'eAuth', 'Log Out');
            $(this).data('mp-ga-user-logout-sent', true);
          }
        });
      });

      //  Trigger GA events for successful login/register.
      const login_cookie_name = 'mp_user_logged_in';
      const register_cookie_name = 'mp_user_create_account';
      if (Cookies.get(login_cookie_name)) {
        // New
        Drupal.analyticsEventNew('login');
        //Old
        Drupal.analyticsEvent('Log In', 'eAuth')
        Cookies.remove(login_cookie_name);
      }
      if (Cookies.get(register_cookie_name)) {
        // New
        Drupal.analyticsEventNew('sign_up');
        //Old
        Drupal.analyticsEvent('Create Account', 'eAuth')
        Cookies.remove(register_cookie_name);
      }

    }
  }

})(jQuery, Drupal, drupalSettings);
